<template>
	<div>
    <back :title="titlename"></back>
		<!-- banner图 -->
		<banner></banner>
    <!-- 业务类型 -->
    <div class="list">
      <div class="ywlist">
        <p>{{title}}</p>
        <li  @click="link(item.YEWUID,item.TYPE,item.NAME)" :key="item.ORDERNUM" v-for="item in ywlist">
          <img :src="images[item.ORDERNUM-1]" alt="">
          <p>{{item.NAME}}</p>
        </li>
        <!-- <router-link :to="{path:'/serviceway',query:{personLX:personlx}}">
          <img src="../assets/images/yw_icon1.png" alt="">
          <p>公司变更</p>
        </router-link> -->
        <!-- <router-link to="/">
          <img src="../assets/images/yw_icon2.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon3.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon1.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon2.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link list-icon to="/">
          <img src="../assets/images/yw_icon3.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link to="/">
          <img src="../assets/images/yw_icon2.png" alt="">
          <p>公司变更</p>
        </router-link>
        <router-link list-icon to="/">
          <img src="../assets/images/yw_icon3.png" alt="">
          <p>更多</p>
        </router-link> -->
      </div>
    </div>

		<!-- 底部 -->
		<!-- <tabbar></tabbar> -->
	</div>

</template>

<script>
   import {Dialog} from 'vant'
export default {
    data() {
      return {
        personlx:"",
        title:"",
        titlename:"元和街道第一窗口",
        ywlist:[],
        SMstatus:"",
        images:[
          require("../assets/images/1.png"),
          require("../assets/images/2.png"),
          require("../assets/images/3.png"),
          require("../assets/images/4.png")
        ]
      };
    },
    created:function(){

    },
    methods:{
      // 业务跳转
      link(obj,type,title){
        if(this.SMstatus!=1){
          Dialog.alert({
            message: '您尚未实名认证，暂不能使用本功能，请前往个人中心进行实名认证',
          }).then(() => {
            this.$router.push("/Realinfo")
          });
        }
        else{
            this.$router.push({path:'/Ywlist',query:{ywId:obj,type:type,title:title}})
        }

      },
      // 获取个人信息
      getperinfo(){
        this.$http.post(this.$store.state.host+"/interface/getUser",{openid:this.$store.state.openId},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.SMstatus=res.body.userPd.status
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      // 获取业务
      getywlist(){
        this.$http.post(this.$store.state.host+"/interface/yewuList",{TYPE:this.personlx},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.ywlist=res.body.list
          }

          //if()
        },res=>{
           //发送失败
        })
      },
    },
    mounted:function(){
      this.personlx=this.$route.query.personLX
      console.log(this.$route.query.personLX)
      this.getperinfo()
      this.getywlist()
      if(this.personlx==2){
        this.title="法人业务"
      }
      if(this.personlx==1){
        this.title="自然人业务"
      }
    },
  };
</script>

<style lang="less" scoped>
  .list{
    padding: .4rem .35rem 0rem;
    .ywlist{
      display: flex;
      flex-wrap: wrap;
      position: relative;
      top:-1rem;
      padding: .26rem;
      font-size: .3rem;
      background: white;
      border-radius: .08rem;
      box-shadow: 0px 0px .05rem #dedede;
      >p{
        width: 100%;
        margin-bottom: .4rem;
      }
      >p::before{
        content: "";
        width: .08rem;
        background: #517be9;
        display: inline-block;
        height: .24rem;
        margin-right: .14rem;
      }
      li{
        width: 25%;
        text-align: center;
        font-size: .24rem;
        margin-bottom: .4rem;
        list-style: none;
        img{
          width: .8rem;
          height: .8rem;
        }
        p{
          margin: 0px;
          color: #333333;
          margin-top: .12rem;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/service.vue